import { render, staticRenderFns } from "./TherapistVisitCount.vue?vue&type=template&id=d084fc24&scoped=true&"
import script from "./TherapistVisitCount.vue?vue&type=script&lang=ts&"
export * from "./TherapistVisitCount.vue?vue&type=script&lang=ts&"
import style0 from "./TherapistVisitCount.vue?vue&type=style&index=0&id=d084fc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d084fc24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
